import { INVALID_MOVE } from 'boardgame.io/core';
import { debug } from '../../utils/debug';
import type { Ctx } from 'boardgame.io';
import type { AoSGameState } from '../../types';
import { validateUpgradeLoco } from '../validators/moveGoodsValidator';

/**
 * 機関車強化Move（基本ルール）
 *
 * コスト: $5
 * 制約: 1ターンに1回のみ（2ラウンド合計で1回）
 *
 * @param G - ゲーム状態
 * @param ctx - Boardgame.ioコンテキスト
 * @returns void or INVALID_MOVE
 *
 * @see docs/specifications/logic/common/phase_05_move_goods.md Section 4.4
 */
export function upgradeLoco(
  { G, ctx }: { G: AoSGameState; ctx: Ctx }
): void | typeof INVALID_MOVE {
  // バリデーション
  const validation = validateUpgradeLoco(G, ctx);
  if (!validation.success) {
    console.error(`[upgradeLoco] Validation failed: ${validation.error} - ${validation.message}`);
    return INVALID_MOVE;
  }

  const player = G.players[ctx.currentPlayer];

  // 機関車強化は無料（商品輸送の代替アクション）
  // コスト: $0

  // 機関車レベル +1
  player.locomotiveLevel += 1;
  player.hasUpgradedLocoThisTurn = true;

  // 手番回数カウント
  player.turnsCompletedThisPhase += 1;

  debug.log(`[upgradeLoco] Player ${ctx.currentPlayer} upgraded locomotive to level ${player.locomotiveLevel} (free), completed turn ${player.turnsCompletedThisPhase}/2`);
}
